export default "__VITE_ASSET__CJPRIZXD__"